import React from 'react';
import { Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import styles from './ActionSelection.module.scss';
import Section from './Section';
import actionsCreator from './Actions';

const ActionSelection = ({ onSelect, onCancel, policy }) => {
	const actions = actionsCreator(policy);
	return (
		<div>
			<div className={styles.sections}>
				{actions.map((section, i) => {
					return <Section key={i} {...section} onSelect={onSelect} policy={policy} />;
				})}
			</div>
			<div className={styles.buttons}>
				<Button id="cancelBtn" primary onClick={onCancel}>Cancel</Button>
			</div>
		</div>
	);
};

ActionSelection.propTypes = {
	onSelect: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
	policy: PropTypes.any
}
export default ActionSelection;
